import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FactorEpochForm } from '../forms/FactorEpochForm';

type FactorEpochModalProps = {
  selectedFactorUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const FactorEpochModal = ({ selectedFactorUuid, isOpen, onClose }: FactorEpochModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={loading}
      title={selectedFactorUuid ? t('factors.editEpochFactor') : t('factors.addEpochFactor')}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <FactorEpochForm selectedFactorUuid={selectedFactorUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
